import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { ModalService } from '../modal/modal.service';
import { FormState, getFormState } from './store/form.reducer';

@Component({
  selector: 'mojo-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent implements AfterViewInit, OnDestroy, OnInit {
  state$: Observable<FormState> = this.store.pipe(select(getFormState), first());
  subscriptions: Subscription[] = [];

  @ViewChild('target', { read: ViewContainerRef })
  viewContainerRef: ViewContainerRef;

  componentRef: ComponentRef<any>;

  constructor(
    private store: Store<{}>,
    private dialogRef: MatDialogRef<FormComponent>,
    private resolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef,
    public modalService: ModalService,
  ) {}

  ngAfterViewInit() {
    this.state$.subscribe((formState: FormState) => {
      const factory = this.resolver.resolveComponentFactory(formState.component);
      this.componentRef = this.viewContainerRef.createComponent(factory);
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.modalService.clean();
      this.componentRef.destroy();
    }
  }

  ngOnInit(): void {
    this.modalService.init(this.dialogRef);
  }
}
